<template>
    <div>
        <div class="cabinet__header-top">
            <RouterLink to="/" class="cabinet__header-logo"></RouterLink>
            <form class="cabinet__header-search" @submit.prevent="sendSearch">
                <input
                    v-model="search"
                    type="text"
                    placeholder="Поиск в каталоге"
                    @keyup.enter="sendSearch"
                />
                <button
                    type="submit"
                    class="cabinet__header-search-loupe"
                ></button>
            </form>
            <div
                class="cabinet__header-burger"
                @click="showHamburgerMenuStore"
            ></div>
            <div class="cabinet__header-buttons">
                <div class="cabinet__header-account" v-if="user">
                    <div
                        :class="{ active: isOpenMenu }"
                        class="cabinet__header-account-head"
                        @click="isOpenMenu = !isOpenMenu"
                    >
                        {{ user.name }} <span class="arrow"></span>
                    </div>
                    <div
                        v-if="isOpenMenu"
                        class="cabinet__header-account-dropdown"
                    >
                        <router-link
                            to="/account/orders"
                            class="cabinet__header-account-dropdown-item"
                            >Заказы</router-link
                        >
                        <router-link
                            to="/account/lists"
                            class="cabinet__header-account-dropdown-item"
                            >Списки</router-link
                        >
                        <router-link
                            to="/account/settings"
                            class="cabinet__header-account-dropdown-item"
                            >Настройки аккаунта</router-link
                        >
                        <a
                            href="/auth/logout"
                            class="cabinet__header-account-dropdown-item"
                            >Выйти</a
                        >
                    </div>
                </div>
                <div class="cabinet__header-account" v-else>
                    <a href="/auth/login" class="cabinet__header-account-head">
                        Войти
                        <span
                            class="cabinet-nav__icon cabinet-nav__icon--login ml-2"
                        ></span>
                    </a>
                </div>
                <!-- <RouterLink
                    :to="`${isRetailerPatch}/cart`"
                    class="cabinet__basket cabinet__basket--home"
                >
                    <i class="cabinet__basket-icon">
                        <span
                            v-if="amountCart > 0"
                            :class="{ 'over-99': amountCart > 99 }"
                            class="cabinet__quantity-in-the-basket"
                            >{{ amountCart > 99 ? '99+' : amountCart }}</span
                        >
                    </i>
                    <span class="cabinet__basket-text"> Корзина</span>
                </RouterLink> -->
            </div>
        </div>
        <div class="cabinet__header-menu">
            <div class="cabinet__header-menu-content">
                <div
                    v-for="categorie in categories"
                    :key="categorie.id"
                    class="cabinet__header-menu-item"
                >
                    <router-link
                        :to="{
                            name: 'CategoryID',
                            params: { id: categorie.url }
                        }"
                        class="cabinet__header-menu-link dropdown-link"
                    >
                        {{ categorie.name }}
                    </router-link>
                </div>
                <div class="cabinet__header-menu-item">
                    <router-link
                        to="/brands"
                        class="cabinet__header-menu-link"
                        >Бренды</router-link
                    >
                </div>
            </div>
            <div class="cabinet__header-menu-arrow">
                <div class="cabinet__header-menu-arrow-btn"></div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
    name: 'SearchAndBasket',

    data() {
        return {
            search: '',
            isOpenMenu: false
        }
    },

    computed: {
        ...mapState('user', ['user']),
        ...mapGetters('user', ['isRetailer']),
        ...mapGetters('publicCategories', ['categories', 'loading']),
        ...mapGetters(['publicSearchGlobal', 'totalAmountCartPublic']),
        ...mapGetters('cart', {
            totalAmountCartRetailer: 'cartCount'
        }),
        activeCategorie() {
            return this.categories.filter(el => el.id === this.categorieID)[0]
        },
        isMobile() {
            return document.documentElement.clientWidth < 767 ? true : false
        },
        isRetailerPatch() {
            return this.isRetailer ? '/account' : ''
        },
        amountCart() {
            return this.isRetailer
                ? this.totalAmountCartRetailer
                : this.totalAmountCartPublic
        }
    },

    created() {
        if (this.$route.params.id === 'all') {
            if (this.publicSearchGlobal) {
                this.search = this.publicSearchGlobal
            }

            if (this.$route.query.search) {
                this.search = this.$route.query.search

                this.setPublicSearchGlobal(this.search)
            }
        }
    },

    methods: {
        ...mapActions(['setPublicSearchGlobal', 'showHamburgerMenuStore']),
        sendSearch() {
            this.setPublicSearchGlobal(this.search)

            this.$router.push({
                name: 'CategoryID',
                params: { id: 'all' },
                query: { search: this.search }
            })
        }
    }
}
</script>

<style>
.cabinet__header-account-head {
    text-decoration: none !important;
    color: #000 !important;
}
</style>
